export default {"src":"/_next/static/media/wincup.dead2d50.svg","height":55,"width":55};